import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../api/authService';
import './LoginPage.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState(''); // For testing only
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await authService.forgotPassword(email);
      setMessage(response.data.message);

      // For testing - remove in production
      if (response.data.resetToken) {
        setResetToken(response.data.resetToken);
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
        'Failed to send reset link. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="background-animation">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
        <div className="floating-shape shape-5"></div>
      </div>

      <div className="login-card fade-in">
        <div className="login-header">
          <div className="brand-logo">
            <span className="logo-icon">🔐</span>
          </div>
          <h2 className="welcome-text">
            Forgot Password
          </h2>
          <p className="page-subtitle">
            Enter your email address and we'll send you a link to reset your password.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <div className="input-wrapper">
              <span className="input-icon">📧</span>
              <input
                type="email"
                className="form-input"
                placeholder=" "
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
              <label className="floating-label">Email Address</label>
            </div>
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              <span>{error}</span>
            </div>
          )}

          {message && (
            <div className="success-message">
              <span className="success-icon">✅</span>
              <span>{message}</span>
            </div>
          )}

          {/* For testing only - remove in production */}
          {resetToken && (
            <div className="test-info">
              <p style={{fontSize: '0.8rem', color: '#666'}}>
                Testing Mode:
                <a
                  href={`/reset-password/${resetToken}`}
                  style={{marginLeft: '5px', color: '#6366f1'}}
                >
                  Click here to reset password
                </a>
              </p>
            </div>
          )}

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="button-spinner"></div>
                <span>Sending...</span>
              </>
            ) : (
              <>
                <span>Send Reset Link</span>
                <span className="button-icon">📤</span>
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>
            Remember your password? {' '}
            <a
              href="/login"
              onClick={(e) => {
                e.preventDefault();
                navigate('/login');
              }}
              style={{color: '#6366f1', fontWeight: 600, textDecoration: 'none'}}
            >
              Back to Login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
